<div class="form-group">
  @if (showLabel && (question?.email_version || question?.question_prompt)) {
    <label class="form-group__label">
      {{question?.email_version ? question?.email_version : question?.question_prompt}}
    </label>
  }
  @for (option of items; track option; let i = $index) {
    <label
      class="selection"
      [ngClass]="{'disable-readonly': readOnly}">
      <!--<input
      *ngIf="option?.answer === 'None of the above'"
      type="checkbox"
      [attr.data-type]="option?.answer === 'None of the above' ? 'exclusive' : ''"
      class="multiselect"
      [value]="option.answer"
      (click)="checkMultiSelect()"
      [name]="uniqueControlName"/>
      <input
        *ngIf="question.answer.indexOf(option.answer) >= 0 && option.answer !== 'None of the above'"
        type="checkbox"
        class="multiselect"
        [checked]="checkIfSelected(option?.answer)"
        [value]="option.answer"
        (click)="checkMultiSelect()"
        [name]="uniqueControlName"/>-->
        <input
          type="checkbox"
          class="multiselect"
          [attr.data-type]="option?.answer === 'None of the above' ? 'exclusive' : ''"
          [value]="option?.answer"
          (change)="onChange($any($event?.target)?.value,$event)"
          [checked]="checkIfSelected(option?.answer)"
          [disabled]="isOptionDisabled(option?.answer)"
          [name]="uniqueControlName"/>
          <div class="selection__inner">
            <div class="selection__main">
              <div class="selection__content">
                <div class="selection__indi"><span></span></div>
                <div class="selection__label">
                  <div class="selection__title">{{option?.answer}}</div>
                  <!-- <div class="selection__subtitle"></div> -->
                </div>
              </div>
            </div>
            <!-- <div class="selection__drawer"></div> -->
          </div>
        </label>
      }
    </div>
